import React from 'react';
import { motion } from 'framer-motion';

const FounderLetter = () => {
  return (
    <section className="py-24 bg-[#FDFCF9]">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto relative">
          {/* Paper Texture/Background */}
          <div className="absolute inset-0 bg-[#f8f5f0] shadow-sm transform -rotate-1 rounded-sm border border-orange-100/50 -z-10"></div>
          <div className="bg-[#fffdfa] shadow-medium p-8 md:p-16 relative border border-orange-50/50">
            
            {/* Badge/Section Title */}
            <div className="mb-8 flex justify-center lg:justify-start">
              <span className="px-4 py-1.5 rounded-full bg-cs-primary/5 text-cs-primary text-xs font-bold uppercase tracking-widest border border-cs-primary/10">
                A personal note from Nikunj, our founder
              </span>
            </div>

            {/* Handwritten Headline */}
            <h2 className="font-handwrite text-3xl md:text-4xl text-cs-primary mb-12 -rotate-1 inline-block">
              Why recruiting has been broken for startups
            </h2>

            {/* Serif Body Text */}
            <div className="font-serif text-lg md:text-xl text-gray-800 leading-relaxed space-y-6">
              <p>
                Hiring today isn't broken because of a lack of candidates.
              </p>

              <p>
                Resume databases and LinkedIn are full of them. The problem is most people are just looking for just another job.
              </p>

              <p>
                Startups need a different breed.
              </p>

              <p>
                People who have the skills, yes — but also the type.<br />
                The ownership. The bias for action. The attitude to build in uncertainty.
              </p>

              <p>
                And that's where things fall apart.
              </p>

              <p className="underline decoration-2 decoration-cs-accent-yellow underline-offset-4">
                People don't come with these labels.<br />
                You only discover their depth and attitude through conversations.
              </p>

              <p>
                But you can only have meaningful conversations with a few — not thousands.
              </p>

              <p className="underline decoration-2 decoration-cs-accent-yellow underline-offset-4">
                That's why we built Cutshort. To help you cut through the clutter and find those few you can connect at a human level.
              </p>

              <p>
                If human-led hiring, scaled with AI, sounds interesting, I'd encourage you to try Cutshort.
              </p>

              <p>
                Wishing you great success ahead,
              </p>
            </div>

            {/* Signature Area */}
            <div className="mt-8 pt-6 border-t border-orange-100/50">
              <div className="flex flex-col gap-4">
                <img 
                  src="/lovable-uploads/nikunj-li.jpeg" 
                  alt="Nikunj Verma" 
                  className="w-20 h-20 rounded-full object-cover border-2 border-orange-100 shadow-sm"
                />
                <div className="font-handwrite text-3xl text-gray-700 -rotate-3 origin-left">
                  Nikunj Verma
                </div>
                <div className="flex items-center gap-3">
                  <p className="text-sm text-gray-500 font-medium whitespace-nowrap">Cofounder, Cutshort</p>
                  <div className="h-3 w-[1px] bg-gray-300"></div>
                  <a 
                    href="http://linkedin.com/in/vermanikunj" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#0077B5] hover:text-[#0077B5]/80 transition-colors"
                    aria-label="Nikunj Verma LinkedIn"
                  >
                    <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            
            {/* Tilt Imperfection Overlay */}
            <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-gray-100/20 to-transparent pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderLetter;
